import styled from "styled-components";

export const TableHeader = styled.div`
  ${(props) => `
    color: ${props.theme.colors.gray};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  padding: 0 1.5rem;

  div {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .main-info-header {
    align-items: flex-start;
  }
`;

export const DamsContainer = styled.div`
  padding: 2rem;
`;
